import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { generateClient } from 'aws-amplify/api';
import { getUrl } from 'aws-amplify/storage'; 
import { listBooks, listExchangeRates } from '../graphql/queries'; 
import './Catalog.css';

const BooksCatalog = () => {
    const navigate = useNavigate();
    const [books, setBooks] = useState([]);
    const [tasa, setTasa] = useState(1);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const client = generateClient();
        const loadBooks = async () => {
            try {
                setLoading(true);
                const resTasa = await client.graphql({ query: listExchangeRates, authMode: 'apiKey' });
                setTasa(resTasa.data.listExchangeRates.items[0]?.value || 1);

                const resBooks = await client.graphql({ query: listBooks, authMode: 'apiKey' });
                const items = resBooks.data.listBooks.items || [];

                const booksWithImages = await Promise.all(items.map(async (book) => {
                    if (book.imageKey) {
                        try {
                            const link = await getUrl({ key: book.imageKey });
                            return { ...book, imageUrl: link.url };
                        } catch (e) { return { ...book, imageUrl: null }; }
                    }
                    return book;
                }));
                setBooks(booksWithImages);
            } catch (err) { console.error(err); } 
            finally { setLoading(false); }
        };
        loadBooks();
    }, []);

    if (loading) return <div className="amazon-container"><p>Cargando obras...</p></div>;

    return (
        <div className="amazon-container">
            <h1 className="amazon-h1">Librería Jurídica Scarvaci</h1>
            <p className="tasa-info">Tasa del día: <strong>{tasa} Bs/$</strong></p>
            
            <div className="amazon-grid-catalog">
                {books.map(book => (
                    <div key={book.id} className="amazon-item-card" onClick={() => navigate(`/book/${book.id}`)}>
                        <div className="amazon-img-placeholder">
                            {book.imageUrl ? <img src={book.imageUrl} alt="" style={{width: '100%', height: '100%', objectFit: 'contain'}} /> : "📖"}
                        </div>
                        <h3>{book.title}</h3>
                        {/* ✅ AUTOR DINÁMICO EN EL CATÁLOGO */}
                        <p className="amazon-author">por {book.author || "Dr. Giovanni Scarvaci"}</p>
                        <div className="amazon-price-box">
                            <span className="usd-price">${book.priceUSD}</span>
                            <span className="bs-price">Bs. {(book.priceUSD * tasa).toFixed(2)}</span>
                        </div>
                        <button className="amazon-buy-button">Ver Màs</button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BooksCatalog;